import styled from '@emotion/styled'
import { TextField } from '@mui/material'
import { CSSProperties } from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form'

interface Props {
  id: string
  name?: string
  control: Control<any>
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  type?: 'text' | 'number' | 'datetime-local' | 'password'
  fullWidth?: boolean
  valiant?: 'standard' | 'outlined' | 'filled'
  errors?: FieldErrors
  size?: 'small' | 'medium'
  style?: CSSProperties
  multiline?: boolean
  rows?: number
  onInput?: (v: string) => void
}

const StyledTextField = styled(TextField)(() => ({
  '& .Mui-disabled': {
    WebkitTextFillColor: 'black',
  },
  '& .MuiInputBase-input': {
    WebkitTextFillColor: 'black',
  },
}))

export default function KanseiTextField(props: Props) {
  const {
    id,
    name,
    label = '',
    placeholder,
    required = false,
    fullWidth = true,
    valiant = 'outlined',
    disabled = false,
    type = 'text',
    control,
    errors = {},
    size = 'small',
    style: style = {},
    multiline = false,
    rows,
    onInput,
  } = props

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onInput) {
      onInput(event.target.value)
    }
  }

  const errorMessage = errors[id]?.message

  return (
    <Controller
      name={name || id}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <StyledTextField
          {...field}
          label={label}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          type={type}
          fullWidth={fullWidth}
          variant={valiant}
          multiline={multiline}
          rows={rows}
          error={!!errorMessage}
          helperText={errorMessage?.toString()}
          size={size}
          sx={style}
          onInput={handleInput}
          autoComplete="off"
        />
      )}
    />
  )
}
